<template>
    <a-modal :open="visible" title="新建标签" @ok="submitForm" @cancel="$emit('cancel')" :confirm-loading="isSubmitting"
        ok-text="创建标签" cancel-text="取消">
        <a-form :model="formData" layout="vertical" ref="formRef">
            <a-form-item label="标签名称" name="name" :rules="[{ required: true, message: '请输入标签名称' }]">
                <a-input v-model:value="formData.name" placeholder="请输入标签名称" :maxlength="30" show-count />
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
import { message } from 'ant-design-vue'
import supabaseTagService from '../../services/supabaseTagService.js'

export default {
    name: 'CreateTagModal',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        existingTags: {
            type: Array,
            default: () => []
        }
    },
    emits: ['cancel', 'success'],
    data() {
        return {
            isSubmitting: false,
            formData: {
                name: ''
            }
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                // 重置表单
                this.formData = {
                    name: ''
                }
                this.$nextTick(() => {
                    this.$refs.formRef?.clearValidate()
                })
            }
        }
    },
    methods: {
        async submitForm() {
            try {
                // 验证表单
                await this.$refs.formRef.validate()

                const name = this.formData.name.trim()
                if (!name) {
                    message.error('请输入标签名称')
                    return
                }

                // 检查标签是否已存在
                const existingTag = this.existingTags.find(tag => tag.name === name)
                if (existingTag) {
                    message.warning('标签已存在')
                    return
                }

                this.isSubmitting = true

                // 创建标签（颜色由数据库触发器生成）
                const newTag = await supabaseTagService.create({
                    name: this.formData.name.trim()
                })

                message.success('标签创建成功！')
                this.$emit('success', newTag)

            } catch (error) {
                console.error('创建标签失败:', error)
                message.error('创建标签失败：' + error.message)
            } finally {
                this.isSubmitting = false
            }
        }
    }
}
</script>